<template>
  <div v-if="projectId">
    <div class="card-body">
      <div class="d-flex mb-2 justify-content-between">
        <h3>Email Invites</h3>
        <div class="flex-shrink-1 text-right">
          <button class="btn btn-primary" @click="onInviteNewUser">
            <i class="fa fa-plus text-white"></i>
            Invite
          </button>
        </div>
      </div>
      <b-row align-h="between">
        <b-col md="3" class="my-1">
          Showing {{ fromItem }} to {{ toItem }} of {{ totalItems }} invite<span v-if="totalItems === 0 || totalItems > 1">s</span>
        </b-col>

        <b-col sm="2" md="3" class="my-1">
          <b-pagination
            :total-rows="totalItems"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0 pagination-holder"
            prev-text="Prev"
            next-text="Next"
            align="fill"
          />
        </b-col>

        <b-col sm="2" md="3" class="my-1">
          <b-form-group
            label="Per Page"
            label-align="right"
            label-cols-sm="7"
            label-cols-md="8"
            label-for="perPageSelect"
            class="mb-0"
          >
            <b-form-select
              v-model="perPage"
              id="perPageSelect"
              size="sm"
              :options="pageOptions"
              align="right"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <b-table
      show-empty
      stacked="md"
      id="projectInvitesTable"
      ref="projectInvitesTable"
      :busy.sync="isBusy"
      :items="getInvites"
      :fields="tableFields"
      :current-page="currentPage"
      :per-page="perPage"
      sort-icon-left
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
    >
      <template v-slot:cell(createdAt)="row">
        <DateTime :date="row.item.createdAt" :dateTime="false"></DateTime>
      </template>
      <template v-slot:cell(options)="row">
        <div v-if="row.item.isExpired" class="options-holder float-right">
          <b-btn
            size=""
            class="my-1 mr-1"
            @click="onDeleteInvite(row.item)"
            alt="Delete Expired Invited"
            title="Delete Expired Invited"
          >
            <font-awesome-icon icon="trash" /> Delete
          </b-btn>
        </div>
      </template>
      <template #table-busy>
        <VueLoader style="height: 200px" text="Loading Invites..." />
      </template>
      <template #empty>
        <h4 class="text-center">
          There are no invites.
        </h4>
      </template>
    </b-table>

    <b-row class="mx-auto" align-h="between">
      <b-col md="3" class="my-1">
        Showing {{ fromItem }} to {{ toItem }} of {{ totalItems }} invite<span v-if="totalItems === 0 || totalItems > 1">s</span>
      </b-col>

      <b-col sm="2" md="3" class="my-1">
        <b-pagination
          :total-rows="totalItems"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0 pagination-holder"
          prev-text="Prev"
          next-text="Next"
          align="fill"
        />
      </b-col>

      <b-col sm="2" md="3" class="my-1">
        <b-form-group
          label="Per Page"
          label-align="right"
          label-cols-sm="7"
          label-cols-md="8"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            v-model="perPage"
            size="sm"
            :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <InviteUserModal @refresh-table="reloadTable()"></InviteUserModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueLoader from "../../../layout/Loader.vue";
import InviteUserModal from "./inviteUserModal.vue";
import DateTime from "../../../../components/common/date-time/DateTime.vue";

export default {
  name: "projectInvites",
  components: {
    VueLoader,
    InviteUserModal,
    DateTime
  },
  data() {
    return {
      pageOptions: [10, 25, 50, 100, 250, 500],
      isBusy: false,
      showModal: null,
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      sortBy: "email",
      sortDesc: false,
      sortDirection: "asc",
      tableFields: [
        {
          key: "email",
          label: "Email Address",
          sortable: true,
          sortDirection: "asc"
        },
        {
          key: "createdAt",
          label: "Date Requested",
          // formatter: val => {
          //   return this.displayDate(val);
          // },
          sortable: true,
          sortDirection: "asc"
        },
        {
          key: "isExpired",
          label: "Status",
          formatter: val => {
            if (val) {
              return "Expired"
            } else {
              return "Active"
            }
          },
          sortable: false,
          sortDirection: "asc"
        },
        { key: "options", label: "Options", sortable: false, class: "text-right" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      projectId: "project/get/id",
      membershipMap: 'user/profile/membershipMap',
      singleInvite: "project/invites/singleInvite",
    }),
    fromItem() {
      return this.totalItems > 0
        ? (this.currentPage - 1) * this.perPage + 1
        : 0;
    },
    toItem() {
      return this.totalItems < this.currentPage * this.perPage
        ? this.totalItems
        : this.currentPage * this.perPage;
    }
  },
  methods: {
    ...mapActions({
      fetchProjectInvites: "project/invites/get",
      deleteInvite: "project/invites/delete",
    }),

    getInvites(ctx) {
      this.isBusy = true;
      let urlParams = `${this.urlBuilder(ctx)}`;
      const data = {urlParams};
      return this.fetchProjectInvites(data).then(data => {
        this.totalItems = data["hydra:totalItems"];
        this.currentPage = ctx.currentPage || 1;
        this.sortBy = ctx.sortBy || "";
        this.isBusy = false;
        return data["hydra:member"].map(invites => {
          return {
            ...invites
          };
        });
      });
    },

    onDeleteInvite(selectedInvite) {
      this.deleteInvite({ id: selectedInvite.id }).then((data) => {
        this.reloadTable()
      });
    },

    reloadTable() {
      this.$refs.projectInvitesTable.refresh();
    },

    onInviteNewUser() {
      this.$bvModal.show('invite-user-modal')
    },

  }
};
</script>

<style></style>
